import { MessageText } from "../../constants/constants.js";

const TEXT = MessageText.statusScreens.ended;

export default function SessionEndedScreen({
  sessionTitle = "this session",
  heading = TEXT.heading,
  buttonLabel = TEXT.buttonLabel,
  redirectSeconds = 10,
}) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 lg:p-8">
      <div className="max-w-md w-full text-center bg-white rounded-2xl shadow-xl p-10 border border-green-100">
        <div className="flex justify-center mb-8">
          <div className="w-20 h-20 rounded-full bg-green-50 flex items-center justify-center border-4 border-white shadow-inner">
            <svg className="w-10 h-10 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        <h2 className="text-2xl font-black text-gray-900 mb-3 tracking-tight">{heading}</h2>

        <p className="text-gray-500 text-sm mb-8 leading-relaxed">
          Thank you for attending <span className="font-medium text-gray-700">{sessionTitle}</span>.
        </p>

        <div>
          <button
            type="button"
            className="px-6 py-2.5 bg-[var(--primary-color)] text-white font-semibold rounded-lg hover:opacity-90 transition-all shadow-md"
          >
            {buttonLabel}
          </button>
          {redirectSeconds > 0 && (
            <p className="mt-3 text-xs text-gray-400">Redirecting automatically in {redirectSeconds}s</p>
          )}
        </div>
      </div>
    </div>
  );
}
